import { Input } from 'app/components/ui/input';
import { Label } from 'app/components/ui/label';
import { SupplierSelector } from 'app/components/ui/supplier-selector';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Supplier } from 'app/pages/SupplierManagement/slice/types';
import { useSupplierManagementSlice } from 'app/pages/SupplierManagement/slice';

function ProductInventory() {
  const form = useFormContext();
  useSupplierManagementSlice(); // Initialize the slice

  const handleSupplierChange = (supplier: Supplier | null) => {
    if (supplier) {
      form.setValue('supplier_id', supplier.supplier_id);
      form.setValue('supplier_name', supplier.supplier_name);
    } else {
      form.setValue('supplier_id', null);
      form.setValue('supplier_name', '');
    }
  };

  return (
    <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm rounded-lg border border-gray-200/50 dark:border-gray-700/50">
      <div className="px-6 py-4 border-b border-gray-100 dark:border-gray-700 bg-gradient-to-r from-orange-50 to-red-50 dark:from-gray-800 dark:to-gray-700 rounded-t-lg">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
            <svg
              className="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100">
              Inventory Details
            </h2>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Manufacturer and supplier information
            </p>
          </div>
        </div>
      </div>

      <div className="p-6 space-y-6">
        <div className="space-y-2">
          <Label
            htmlFor="manufacturer"
            className="text-xs font-medium text-gray-800 dark:text-gray-200 flex items-center"
          >
            <span className="w-1.5 h-1.5 bg-gradient-to-r from-orange-500 to-red-500 rounded-full mr-2"></span>
            Manufacturer
          </Label>
          <Input
            id="manufacturer"
            type="text"
            placeholder="Enter manufacturer name"
            className="h-10 bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 rounded-lg transition-all duration-200 text-sm"
            {...form.register('manufacturer')}
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 px-2 py-1 rounded">
            Optional manufacturer information
          </p>
        </div>

        <SupplierSelector
          value={form.watch('supplier_id')}
          onChange={handleSupplierChange}
          placeholder="Search suppliers..."
        />
      </div>
    </div>
  );
}

export default ProductInventory;
